<template>
    <div class="container">
        <h4 class="text-primary">Simulador de Crédito</h4>
        <div class="row">
            <div class="col-md-8 col-12 order-2 order-md-1">
                <div class="kt-portlet">
                    <div class="kt-portlet__body">
                        <div class="kt-section">
                            <div class="kt-section__content">
                                <form class="row p-md-5 p-sm-1" @submit.prevent="validar">
                                    <div class="form-group col-12">
                                        <label>Plazo</label>
                                        <combo-box v-model="formulario.plazo" :opciones="lstPlazos" name="plazo"
                                                   v-validate="{required:true,obj:true}"></combo-box>
                                        <span class="form-text text-danger">{{errors.first("plazo")}}</span>
                                    </div>
                                    <div class="form-group col-12">
                                        <label>Valor entrada</label>
                                        <input type="number" class="form-control" v-model="formulario.valor"
                                               v-on:input="encerar" name="valor"
                                               v-validate="{required:true,decimal:2,min_value:minimo,max_value:maximo}"
                                               step="any">
                                        <span class="form-text text-danger">{{errors.first("valor")}}</span>
                                    </div>
                                    <div class="col-md-6 col-12 p-1">
                                        <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block" :disabled="cargandoCuota">
                                            Calcular
                                        </button>
                                    </div>
                                    <div class="col-md-6 col-12 p-1">
                                        <button type="button"
                                                class="btn btn-outline-primary btn-elevate btn-pill btn-block"
                                                v-on:click="limpiar">Limpiar
                                        </button>
                                    </div>
                                </form>
                                <div class="row">
                                    <div class="kt-portlet kt-iconbox kt-iconbox--wave">
                                        <div class="kt-portlet__body">
                                            <div class="kt-iconbox__body">
                                                <div class="kt-iconbox__desc">
                                                    <h5 class="kt-iconbox__title text-primary linea2">Detalle de
                                                        simulación</h5>
                                                    <div class="kt-iconbox__content">
                                                        <div class="p-0 m-0">
                                                            <div class="pt-5 pb-5 row">
                                                                <div class="order-2 order-md-1 col-md-6 col-12 text-center p-0 m-0 d-flex align-items-center">
                                                                  <div class="container-fluid">
                                                                    <div class="col-12 d-flex justify-content-center p-0 m-0">
                                                                      <h5 class="text-muted p-0 m-0">Cuota mensual
                                                                        aprox.</h5>
                                                                    </div>
                                                                    <div class="col-12 d-flex justify-content-center p-0">
                                                                      <p class="p-0 m-0">
                                                                        <numero-animado
                                                                            :number="formulario.respuesta"></numero-animado>
                                                                      </p>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                                <div class="order-1 order-md-2 col-md-6 col-12">
                                                                    <div class="row d-flex align-items-center bd-highlight mb-3">
                                                                        <table class="table-sm container-fluid">
                                                                            <tbody>
                                                                            <tr>
                                                                                <td class="text-primary">
                                                                                    Plazo
                                                                                </td>
                                                                                <td class="text-right">
                                                                                    {{formulario.plazo.dt1}}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td class="text-primary">
                                                                                    Entrada
                                                                                </td>
                                                                                <td class="precio-syb text-right">
                                                                                    {{punto(formulario.valor||0)}}
                                                                                </td>
                                                                            </tr>
                                                                            <template v-for="(item,index) in resultado">
                                                                              <tr :key="index" v-if="item.bdt1">
                                                                                <td class="text-primary text-capitalize">
                                                                                  {{ minusculas(item.dt1) }}
                                                                                </td>
                                                                                <td class="text-right">
                                                                                  <span class="precio-syb">{{punto(item.ndt1)}}</span>
                                                                                </td>
                                                                              </tr>
                                                                            </template>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-12">
                                                                <button type="button"
                                                                        class="btn btn-primary btn-elevate btn-pill btn-block"
                                                                        v-on:click="abrirModal">Presentar solicitud
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row text-primary text-justify">
                                    *Los valores presentados en esta simulación son aproximados y pueden variar según
                                    las tasas de interés vigentes y las condiciones de crédito.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-12 order-1 order-md-2">
                <resumen></resumen>
            </div>
        </div>
        <b-modal id="modal-scrollable" ref="privacy" size="lg" hide-footer hide-header title="Kia" body-class="m-0 p-0">
            <modal-privacidad :funcion="enviarDatos"></modal-privacidad>
        </b-modal>
    </div>
</template>

<script>
    import resumen from "../../../../componentes/resumen-vertical-online";
    import comboBox from "../../../../componentes/comboBox";
    import {calculo, catalogos, negociacion} from "../../../../servicios";
    import _ from 'lodash';
    import numeroAnimado from "../../../../componentes/numero-animado";
    import constantes from "../../../../constantes";
    import modalPrivacidad from "../../../../componentes/modal-privacidad";

    export default {
        name: "solicitud",
        components: {
            resumen,
            comboBox,
            numeroAnimado,
            modalPrivacidad
        },
        data: () => ({
            formulario: {
                banco: constantes.Constantes.enumeraciones.calculoCuota,
                plazo: {id: null},
                valor: 0,
                respuesta: null
            },
            resultado: [],
            maximos: {
                ndt1: 1,
            },
            lstPlazos: [],
            procesando: false,
          cargandoCuota: false,
        }),
        watch: {
            "formulario.plazo.id": function () {
                this.encerar();
            }
        },
        computed: {
            valorFincnanciar: function () {
                const a = this.$store.getters.getCotizacion.ndt3 - this.formulario.valor;
                if (a >= 0)
                    return a;
                else
                    return 0;
            },
            minimo: function () {
                return ((this.$store.getters.getCotizacion.ndt3 * this.maximos.ndt1.toFixed(2)) / 100).toFixed(1);
            },
            maximo: function () {
                return (this.$store.getters.getCotizacion.ndt3).toFixed(2);
            }
        },
        methods: {
            punto: (n) => constantes.funciones.puntoMilesDecimal(parseFloat(n)),
            minusculas: (n) => constantes.funciones.minusculas(n),
            limpiar: function () {
              this.formulario.plazo = {id:null};
              this.formulario.respuesta = null;
              this.formulario.valor = ((this.$store.getters.getCotizacion.ndt3 * this.maximos.ndt1.toFixed(2)) / 100).toFixed(1);
              this.encerar();
            },
            encerar: function () {
              this.formulario.respuesta = null;
              this.resultado = [];
            },
            cargarPlazos: function () {
                catalogos.listaPlazos(this.formulario.banco).then(r => r.data).then(response => {
                    this.lstPlazos = response;
                });
                calculo.cuotas().then(r => r.data).then(response => {
                    this.maximos = response;
                    this.formulario.valor = ((this.$store.getters.getCotizacion.ndt3 * this.maximos.ndt1) / 100).toFixed(1);
                });
            },
            calculorCuota: function () {
                this.cargandoCuota = true;
                calculo.calculoCuota(this.$store.getters.getCotizacion, this.formulario).then(r => r.data).then(response => {
                    this.resultado = response;
                    this.formulario.respuesta = response[response.length - 1].ndt1;
                  this.cargandoCuota = false;
                }).catch(()=>{
                  this.cargandoCuota = false;
                });
            },
            validar: function () {
                this.$validator.validateAll().then((result) => {
                    if (result)
                        this.calculorCuota();
                    else
                        this.$toast.show(`Completa el formulario`);
                });
            },
            enviarDatos: _.debounce(function () {
                negociacion.actualizaACuota(this.formulario).then(() => {
                    this.$router.push({name: 'compras.credito.solicitud'});
                }).catch(() => {
                    this.$refs['privacy'].toggle();
                });
            }, 500),
            abrirModal: function () {
                if (this.formulario.respuesta > 0) {
                    this.$refs['privacy'].toggle();
                } else {
                    this.$toast.show(`Calcula una cuota`);
                }
            }
        },
        created() {
            this.cargarPlazos();
        }
    }
</script>

<style scoped>
    p {
        font-size: 4em;
        font-weight: bold;
    }

    h5, p {
        line-height: 1em;
    }
</style>
